import { useSelector } from 'react-redux';
import { getUserInfoSelector } from '../redux/profile/profileSelectors';

export const checkUserRole = (...userRoles: string[]) => {
  const { roles } = useSelector(getUserInfoSelector);

  return userRoles.some((role: string) => roles?.includes(role));
};
